import { CommonModule } from "@angular/common";
import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  inject,
  Injectable
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";

@Component({
  selector: 'PopUpView',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './PopUpView.html',
  styleUrl: './PopUpView.css'
})
export class PopUpView {
  @Input() icon: string = '';
  @Input() text: string = '';
  @Input() btnClass: string = 'btn-primary';
  @Input() header: string = '';
  @ContentChild('staticContent') staticElement!: TemplateRef<any>;

  @Output() btnClick = new EventEmitter<void>();
  @Output() PopupClosed = new EventEmitter<void>();

  private modalService = inject(NgbModal);

  ShowPopup() {

    this.btnClick.emit();

    var modal = this.modalService.open(PopUpViewPopup)
    modal.componentInstance.header = this.header;
    modal.componentInstance.staticElement = this.staticElement;
    modal.closed.subscribe({
      next: async (config) => {
        this.PopupClosed.emit();
        console.log("Close");
      },
      error: (err) => {
        this.PopupClosed.emit();
        console.log("Close");
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.PopupClosed.emit();
        console.log("Close");
      },
      error: (err) => {
        this.PopupClosed.emit();
        console.log("Close");
      },
    });
  }

}




@Component({
  selector: 'PopUpViewPopup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './PopUpViewPopup.html',
  styleUrl: './PopUpView.css'
})

class PopUpViewPopup {
  @Input() header: string = '';
  @Input() staticElement!: TemplateRef<any>;

  modal = inject(NgbActiveModal);
}
